import { takeEvery, call, put, select } from 'redux-saga/effects';
import Cookies from 'universal-cookie';
import {
  resetState,
  sendFormRequest,
  requestFinished,
  setErrors,
  selectFormBody,
  selectFieldVerifyCode,
  clearAllErrors
} from '../../../../common/reducers/forms/signInForm';

import { sendGetAuthAccountDataRequest } from '../../../../common/reducers/states/authAccount';
import { sendRequest as sendRequestGetReferenceLists } from '../../../../../main/reducers/static/states/referenceLists/reducer';
import { sendRequest as sendRequestGetCounts } from '../../../../../main/reducers/static/states/counts/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserService from '../../../../services/UserService';
import { sendRequestGetCaptcha } from '../../../../../main/reducers/static/states/captcha/reducer';

const cookies = new Cookies();

function* signInFormSaga(reducerName) {
  const formBody = yield select(selectFormBody, reducerName);
  try {
    yield put(clearAllErrors(reducerName));
    const response = yield call(timeoutCall, UserService.auth, formBody);
    if (response) {
      if (response.status === 422) {
        yield put(setErrors(reducerName, response.data));
        // Если валидация капчи прошла то она обновилась на сервере, загружаем новую
        const fieldVerifyCode = yield select(
          selectFieldVerifyCode,
          reducerName
        );
        if (fieldVerifyCode.errors.length === 0) {
          yield put(sendRequestGetCaptcha());
        }
      } else if (response.status === 200) {
        cookies.set('auth_key', response.data.auth_key, { path: '/' });
        localStorage.setItem('auth_key', response.data.auth_key);
        yield put(resetState(reducerName));
      }
    }
    yield put(
      requestFinished(reducerName, response.status, response.status === 200)
    );
    if (response.status === 200) {
      yield put(sendGetAuthAccountDataRequest());
      yield put(sendRequestGetReferenceLists());
      yield put(sendRequestGetCounts());
    }
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [
    takeEvery(sendFormRequest(reducerName).type, signInFormSaga, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/forms/sagas/signInFormSaga.js